/**
 * Fonction utilitaire pour envoyer des données vers Google Sheets via Google Apps Script
 */
export async function submitToGoogleSheets(formData: Record<string, any>, source: string) {
  const GOOGLE_SCRIPT_URL = process.env.NEXT_PUBLIC_GOOGLE_SCRIPT_URL || 
    'https://script.google.com/a/macros/greenora.fr/s/AKfycbwKfYXpXOXT3wcENHU_J1bycKnKvrfTPPvXCE2L3N4gGN-UsrLO86UQLMAOarugjwiESA/exec';

  // Préparer les données avec les noms de colonnes exacts de votre Google Sheet
  const data = {
    'Raison Social': formData.company || '',
    'Nom Prenom': formData.name || (formData.firstName && formData.lastName ? `${formData.firstName} ${formData.lastName}`.trim() : ''),
    'Fonction': formData.function || formData.fonction || '',
    'Email': formData.email || '',
    'Tel': formData.phone || formData.tel || '',
    'Type de projet': formData.projectType || formData.segment || formData.service || '',
    'Message': formData.message || '',
  };

  console.log('📤 Envoi vers Google Sheets:', data);

  try {
    // Envoyer directement depuis le client vers Google Apps Script
    // Google Apps Script attend les données JSON dans e.postData.contents
    const response = await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    // En mode no-cors, on ne peut pas vérifier la réponse
    // Mais on retourne true car la requête a été envoyée
    return { success: true };
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi vers Google Sheets:', error);
    throw error;
  }
}

